import { render, staticRenderFns } from "./Evamat.vue?vue&type=template&id=438050a7&lang=true"
import script from "./Evamat.vue?vue&type=script&lang=js"
export * from "./Evamat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports